module.exports = "/legacy/2665799161388b86c795c30d1f6f2847.svg";